import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'livestream-embed',
  templateUrl: './livestream-embed.component.html',
  styleUrls: ['./livestream-embed.component.scss']
})
export class LivestreamEmbedComponent implements OnInit {
  
  // Update prop with current embed code url. Will be sanitized and output to the iframe.
  embedCode: string = 'https://www.youtube.com/embed/SbB__XTTDHg';
  safeEmbed: any;

  // Set to false to remove SpeedVideo sponsorship assets.
  sponsored: boolean = false; 

  hasSchedule: boolean = false;

  constructor(public sanitizer: DomSanitizer) {
    this.safeEmbed = this.sanitizer.bypassSecurityTrustResourceUrl( this.embedCode );
  }

  ngOnInit() {
  }

}
